import { FEATURE_UNIQ_KEY } from '../../constants';
import type { UserId } from '../../types';
import { normalizeUserId } from '../user-id';

export const buildEnvelopeKey = (storageName: string, userId: UserId) => {
    return `${FEATURE_UNIQ_KEY}:${storageName}:${normalizeUserId(userId)}`;
};
